module.exports = __webpack_public_path__ + "img/companySolutionImg.8ffaff49.png";